export default function SocialIcons() {
  return (
    <div className="fixed top-1/2 right-0 transform -translate-y-1/2 bg-gray-900 p-2 rounded-l-lg shadow-lg flex flex-col gap-3">
      <a href="https://wa.me/919999999999" className="hover:scale-110 transition-transform">
        <img src="/icons/whatsapp.svg" alt="WhatsApp" className="w-8" />
      </a>
      <a href="https://instagram.com/" className="hover:scale-110 transition-transform">
        <img src="/icons/instagram.svg" alt="Instagram" className="w-8" />
      </a>
      <a href="https://facebook.com/" className="hover:scale-110 transition-transform">
        <img src="/icons/facebook.svg" alt="Facebook" className="w-8" />
      </a>
      <a href="https://linkedin.com/" className="hover:scale-110 transition-transform">
        <img src="/icons/linkedin.svg" alt="LinkedIn" className="w-8" />
      </a>
    </div>
  );
}
